import React , {Component} from 'react';

import { connect } from "react-redux";
import {
  App,
  Views,
  View,
    Link ,Toolbar
} from 'framework7-react';


import routes from '../js/routes';
import AppToolbar from "../div/AppToolbar";
import {toolbar} from "../actions";

class app extends Component {
  constructor() {
    super();


    this.state = {
      // Framework7 Parameters
       tabName : "restaurant" ,
      toolbarShow : true ,
      f7params: {

        // App routes
        routes: routes,
        // Register service worker
        serviceWorker: {
          path: '/service-worker.js',
        },
      },
    }
  }


    tabProfileClick()
    {
        this.setState({
            tabName : "profile"
        })
    }

    tabContactClick()
    {
        this.setState({
            tabName : "contact"
        })
    }
    tabOrdersClick()
    {
        this.setState({
            tabName : "orders"
        })
    }

    tabRestaurantClick()
    {
        this.setState({
            tabName : "restaurant"
        })
    }


    componentDidMount() {
        this.$f7ready((f7) => {
            // Call F7 APIs here

        });
    }

  render() {

      try {
          this.setState({
              toolbarShow : this.props.toolbarShow
          })
      }
      catch (e) {}

    return (




                <App params={ this.state.f7params } >

                    <div className="b-container h-100 p-0">
                        <div className="b-row justify-content-center  h-100">
                            <div className="b-col-md-6  h-100">
                              {/* Views/Tabs container */}
                              <Views tabs className="safe-areas" >
                                  {/* Tabbar for switching views-tabs */}

                                  {/*<AppToolbar show={this.state.toolbarShow} />*/}






                                  <div id="footer-tabs-container" className={this.state.toolbarShow ? "show" : "dont-show"}>

                                      <div className="b-container p-0" >
                                          <div className="b-row no-gutters justify-content-center">
                                              <div className="b-col-md-6">
                                                  <div  id="footer-tabs">


                                                      <Toolbar labels bottom tabbar id="footer-tabs">

                                                          <Link href="/profile/" className={this.state.tabName === "profile" ? `active` : ``}  onClick={this.tabProfileClick.bind(this)} >
                                                              <img className="img off" src="https://www.lavefood.com/webappassets/images/toolbar-profile-tab-off.svg" />
                                                              <img className="img on" src="https://www.lavefood.com/webappassets/images/toolbar-profile-tab-on.svg" />
                                                              <div className="title">
                                                                  پروفایل
                                                              </div>
                                                          </Link>

                                                          <Link href="/contact/" className={this.state.tabName === "contact" ? `active` : ``}  onClick={this.tabContactClick.bind(this)} >
                                                              <img className="img off" src="https://www.lavefood.com/webappassets/images/toolbar-contact-tab-off.svg" />
                                                              <img className="img on" src="https://www.lavefood.com/webappassets/images/toolbar-contact-tab-on.svg" />
                                                              <div className="title">
                                                                  تماس
                                                              </div>
                                                          </Link>



                                                          <Link href="/orders-list/" className={this.state.tabName === "orders" ? `active` : ``}  onClick={this.tabOrdersClick.bind(this)} >
                                                              <img className="img off" src="https://www.lavefood.com/webappassets/images/toolbar-orders-tab-off.svg" />
                                                              <img className="img on" src="https://www.lavefood.com/webappassets/images/toolbar-orders-tab-on.svg" />
                                                              <div className="title">
                                                                  پیشینه سفارشات
                                                              </div>
                                                          </Link>



                                                          <Link href="/" className={this.state.tabName === "restaurant" ? `active` : ``}  onClick={this.tabRestaurantClick.bind(this)} >
                                                              <img className="img off" src="https://www.lavefood.com/webappassets/images/toolbar-resturan-tab-off.svg" />
                                                              <img className="img on" src="https://www.lavefood.com/webappassets/images/toolbar-resturan-tab-on.svg" />
                                                              <div className="title">
                                                                  رستوران ها
                                                              </div>
                                                          </Link>

                                                      </Toolbar>

                                                  </div>
                                              </div>
                                          </div>
                                      </div>

                                  </div>




                                  {/* Your main view/tab, should have "view-main" class. It also has "tabActive" prop */}
                                  <View id="branch-list" main name="BranchList" tab tabActive url="/" pushState={true} />
                                  {/* Catalog View */}
                                  {/*<View id="orders-list" name="ordersList" tab url="/orders-list/" pushState={true}/>*/}
                                  {/* Settings View */}
                                  {/*<View id="contact" name="contact" tab url="/contact/" pushState={true}/>*/}
                                  {/* Settings View */}
                                  {/*<View id="profile" name="profile" tab url="/profile/" pushState={true}/>*/}
                              </Views>
                            </div>
                        </div>
                    </div>
                </App>



    )
  }
}





const mapStateToProps = state => {
    return {
        toolbarShow : state.toolbar
    }
}

export default connect( mapStateToProps )(app);
